import { Injectable } from '@angular/core';
import { ApplicationAdvisoriesListAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { ALERT } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { AlertAdvisoriesExtendedHelper } from './alert-advisories-extended-helper.facade';

@Injectable({
  providedIn: 'root'
})
export class AlertAdvisoriesFacadeHelper extends AlertAdvisoriesExtendedHelper {
  checkAdvicoryCookie(
    contextPath: string,
    value: ApplicationAdvisoriesListAem,
    advicoryCookie?: string | null
  ): void {
    if (!advicoryCookie) {
      this.isAdvisoryMatch = true;
      this.selectedAdvisory = value;
      this.adAlertCookie = contextPath + ':' + value.advisoryKey;
    } else {
      this.checkAdvisoryCookieLength(advicoryCookie, contextPath, value);
    }
  }

  checkAdvisoryCookieLength(
    advicoryCookie: string,
    contextPath: string,
    value: ApplicationAdvisoriesListAem
  ): void {
    if (advicoryCookie.length > 0) {
      this.checkAdvisoryAppCookie(advicoryCookie, contextPath, value);
      this.setAdAlertCookie(this.isADNewCookierequired, this.adCookieArray);
    }
  }

  setAdAlertCookie(
    isADNewCookieRequired: boolean,
    adCookieArray: string[]
  ): void {
    if (isADNewCookieRequired && adCookieArray) {
      this.adAlertCookie = adCookieArray.toString();
    }
  }

  checkAdvisoryMatch(): void {
    if (!this.isAdvisoryMatch) {
      this.showAlertAdvisoriesHeader.set(
        this.adapter.setDefaultDisplay ? this.setDefaultAdvisories() : false
      );
    } else if (this.selectedAdvisory) {
      this.advisories = this.selectedAdvisory;
      this.setShowAlertAdvisoriesHeader();
    }
  }

  setShowAlertAdvisoriesHeader(): void {
    if (
      this.darkSiteThemeContent?.isEnabled === this.isEnabled ||
      this.appConfig.get('APP') !== 'homepage'
    ) {
      this.showAlertAdvisoriesHeader.set(false);
    } else {
      this.showAlertAdvisoriesHeader.set(true);
    }
  }

  getAdvisoryContent(
    contextPath: string,
    value: ApplicationAdvisoriesListAem,
    advicoryCookie?: string | null
  ) {
    const apptype = value.apptype;
    if (contextPath && contextPath === apptype && value.advisoryKey !== '') {
      return this.checkAdvicoryCookie(contextPath, value, advicoryCookie);
    }
    return null;
  }

  checkNumberOfAdvisories(
    applicationAdvisories: ApplicationAdvisoriesListAem[]
  ) {
    const windowPath = window.location.pathname;
    const contextPath = this.setContextPath(windowPath);
    const numberOfAdvisories = applicationAdvisories.length;
    const advicoryCookie = this.cookieHelper.getCookieValue(ALERT.ADD_ALERT);

    if (numberOfAdvisories > 0) {
      applicationAdvisories.forEach((value) => {
        return this.getAdvisoryContent(contextPath, value, advicoryCookie);
      });
    }
  }
}
